module.exports = __webpack_public_path__ + "img/sample_07_big.a65c80f2.gif";